import { ContentSource } from 'constants/tracking/content-sources'

import type { TrackingEvent } from '@marketplace-web/shared/event-tracker-data'

type ClickClosetPromotionEventArgs = {
  ownerId: number
  contentSource: ContentSource
  target: string
}

type ClickClosetPromotionEventExtra = {
  owner_id: number
  content_source: ContentSource
  target: string
}

export const clickClosetPromotionEvent = (args: ClickClosetPromotionEventArgs) => {
  const { contentSource, target, ownerId } = args

  const extra: ClickClosetPromotionEventExtra = {
    owner_id: ownerId,
    content_source: contentSource,
    target,
  }

  return {
    event: 'user.click_closet_promotion',
    extra,
  }
}

type ClickClaimYourGiftEventArgs = {
  screen: string
}

type ClickClaimYourGiftEventExtra = {
  screen: string
}

export const clickClaimYourGiftEvent = (args: ClickClaimYourGiftEventArgs): TrackingEvent => {
  const { screen } = args

  const extra: ClickClaimYourGiftEventExtra = { screen }

  return {
    event: 'user.click_claim_your_gift',
    extra,
  }
}

type ClickReduceItemPriceEventArgs = {
  screen: string
}

type ClickReduceItemPriceEventExtra = {
  screen: string
}

export const clickReduceItemPriceEvent = (args: ClickReduceItemPriceEventArgs): TrackingEvent => {
  const { screen } = args

  const extra: ClickReduceItemPriceEventExtra = { screen }

  return {
    event: 'user.click_reduce_item_price',
    extra,
  }
}

type ClickConfirmReduceItemPriceEventArgs = {
  screen: string
}

type ClickConfirmReduceItemPriceEventExtra = {
  screen: string
}

export const clickConfirmReduceItemPriceEvent = (
  args: ClickConfirmReduceItemPriceEventArgs,
): TrackingEvent => {
  const { screen } = args

  const extra: ClickConfirmReduceItemPriceEventExtra = { screen }

  return {
    event: 'user.click_confirm_reduce_item_price',
    extra,
  }
}

type ClickCancelReduceItemPriceEventArgs = {
  screen: string
}

type ClickCancelReduceItemPriceEventExtra = {
  screen: string
}

export const clickCancelReduceItemPriceEvent = (
  args: ClickCancelReduceItemPriceEventArgs,
): TrackingEvent => {
  const { screen } = args

  const extra: ClickCancelReduceItemPriceEventExtra = { screen }

  return {
    event: 'user.click_cancel_reduce_item_price',
    extra,
  }
}

type ReducePriceSuccessfullyEventArgs = {
  screen?: string
}

type ReducePriceSuccessfullyEventExtra = {
  screen?: string
}

export const reducePriceSuccessfullyEvent = (
  args: ReducePriceSuccessfullyEventArgs,
): TrackingEvent => {
  const { screen } = args

  const extra: ReducePriceSuccessfullyEventExtra = { screen }

  return {
    event: 'user.reduce_price_successfully',
    extra,
  }
}
